import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PasswordChecklist from "react-password-checklist";
import { TabPanel, Tabs } from "react-tabs";
import { generateOtp, registration } from "../../services/AuthServices";
import { getUser, signIn } from "../../auth/Auth";
import { EMAIL_REGEX, PASSWORD_REGEX } from "../../Constants";
import ReactLoading from "react-loading";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import imgMI from "../../assets/images/media-intelligence-icon.png";

function SignUp() {
  const [showPass, setShowPass] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [is_checked, setIsChecked] = useState(false);
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");
  const [password_confirmation, setPasswordConfirmation] = useState("");
  const [validate, setValidate] = useState(true);
  const [checkPassword, setCheckPassword] = useState(false);
  const [checkPasswordConfirmation, setCheckPasswordConfirmation] =
    useState(false);
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    password_confirmation: "",
    is_checked: "",
  });
  const navigate = useNavigate();

  const resetErrors = () => {
    setErrors({
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      password_confirmation: "",
      is_checked: "",
    });
  };

  const errorsRequired = t("Notifications.error.errorRequired");
  const errorEmail = t("Notifications.error.errorWrongEmail");
  const errorNospasce = t("Notifications.error.errorNospace");
  const errorsPasswordPattern = t("Notifications.error.errorsPasswordPattern");
  const errorsCkecked = t("Notifications.error.errorTermsOfuse");
  const errorsEqual = t("Notifications.error.errordiffPassword");

  const notify = (message, origin) => toast[origin](message);

  const handleFormChange = (e) => {
    resetErrors();
    const { name, value } = e.target;
    setValidate(false);

    switch (name) {
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "company":
        setCompany(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "password":
        setPassword(value);
        setCheckPassword(value !== "");
        break;
      case "password_confirmation":
        setPasswordConfirmation(value);
        setCheckPasswordConfirmation(value !== "");
        break;
      case "checkbox_terms":
        setIsChecked(!is_checked);
        break;
      default:
        break;
    }
  };

  const formVerification = () => {
    let updatedErrors = {};

    if (firstName.trim() === "") {
      updatedErrors.firstName = errorsRequired;
    }

    if (lastName.trim() === "") {
      updatedErrors.lastName = errorsRequired;
    }

    if (email.trim() === "") {
      updatedErrors.email = errorsRequired;
    } else if (!email.match(EMAIL_REGEX)) {
      updatedErrors.email = errorEmail;
    }

    if (password.trim() === "") {
      updatedErrors.password = errorsRequired;
    } else if (!password.trim().match(PASSWORD_REGEX)) {
      updatedErrors.password = errorsPasswordPattern;
    } else if (password.includes(" ")) {
      updatedErrors.password = errorNospasce;
    }

    if (password_confirmation.trim() === "") {
      updatedErrors.password_confirmation = errorsRequired;
    } else if (password_confirmation.trim() !== password.trim()) {
      updatedErrors.password_confirmation = errorsEqual;
    }

    if (!is_checked) {
      updatedErrors.is_checked = errorsCkecked;
    }

    setErrors({
      ...errors,
      ...updatedErrors,
    });

    setValidate(true);

    return Object.keys(updatedErrors).length === 0;
  };

  const register = async (e) => {
    e.preventDefault();
    const isFormValid = formVerification();

    if (isFormValid) {
      setIsLoading(true);
      try {
        const data = {
          first_name: firstName,
          last_name: lastName,
          email: email,
          password: password,
          phone: phone,
          about_me: company,
          password_confirmation: password_confirmation,
        };

        const response = await registration(data);

        if (response.success === true) {
          notify(response.message, "success");
          signIn(response);

          const res = await generateOtp(getUser().id);
          const otp = res.data.otp.otp;

          if (otp) {
            window.location.replace(
              process.env.REACT_APP_CLIENT_SERVICE + "?otp=" + otp
            );
          }
        } else {
          notify(t("Notifications.error.errorOccur"), "error");
        }
        resetForm();
      } catch (error) {
        notify(t("Notifications.error.errorOccur"), "error");
      } finally {
        setIsLoading(false);
      }
    } else {
      // Si le formulaire n'est pas valide, nous n'activons pas l'état de chargement
      // mais les erreurs ont déjà été mises à jour dans formVerification
    }
  };

  const resetForm = () => {
    setEmail("");
    setFirstName("");
    setLastName("");
    setPassword("");
    setPasswordConfirmation("");
    setIsChecked(false);
    setCheckPassword(false);
    setCheckPasswordConfirmation(false);
  };

  const renderErrorMessage = (errorMessage) => {
    return validate && errorMessage ? (
      <span
        style={{
          color: "red",
          fontWeight: "italic",
        }}
      >
        {errorMessage}
      </span>
    ) : null;
  };

  return (
    <section className="account-section">
      <div className="tf-container">
        <div className="row">
          <div>
            <ToastContainer />
          </div>
          <Tabs className="wd-form-login tf-tab">
            <a
              href={
                process.env.REACT_APP_CLIENT_SERVICE || "http://localhost:3000"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={imgMI} className="mb-4" alt="logo" />
            </a>
            <h4>{t("account.AccountInfo")}</h4>
            <div className="content-tab">
              <TabPanel className="inner animation-tab">
                <form onSubmit={register}>
                  <div className="ip">
                    <label>
                      {t("account.Account_Fname")}
                      <span>*</span>
                    </label>
                    <input
                      type="text"
                      onChange={handleFormChange}
                      placeholder={t("account.Account_Fname")}
                      value={firstName}
                      name="firstName"
                    />
                    {renderErrorMessage(errors.firstName)}
                  </div>

                  <div className="ip">
                    <label>
                      {t("account.Account_Lname")}
                      <span>*</span>
                    </label>
                    <input
                      type="text"
                      onChange={handleFormChange}
                      placeholder={t("account.Account_Lname")}
                      name="lastName"
                      value={lastName}
                    />
                    {renderErrorMessage(errors.lastName)}
                  </div>

                  <div className="ip">
                    <label>
                      {t("account.AccountEmail")}
                      <span>*</span>
                    </label>
                    <input
                      type="text"
                      onChange={handleFormChange}
                      placeholder={t("account.AccountEmail")}
                      name="email"
                      value={email}
                    />
                    {renderErrorMessage(errors.email)}
                  </div>

                  <div className="ip">
                    <label>
                      {t("account.AccountPhone")}
                      <span>*</span>
                    </label>
                    <input
                      type="text"
                      onChange={handleFormChange}
                      placeholder={t("account.AccountPhone")}
                      name="phone"
                      value={phone}
                    />
                  </div>

                  <div className="ip">
                    <label>{t("account.AccountCompany")}</label>
                    <input
                      type="text"
                      onChange={handleFormChange}
                      placeholder={t("account.AccountCompanyName")}
                      name="company"
                      value={company}
                    />
                  </div>

                  <div className="ip">
                    <label>
                      {t("account.AccountPass")}
                      <span>*</span>
                    </label>
                    <div className="inputs-group auth-pass-inputgroup">
                      <input
                        type={showPass ? "text" : "password"}
                        className="input-form password-input"
                        onChange={handleFormChange}
                        placeholder={t("account.AccountPass")}
                        required
                        name="password"
                        value={password}
                      />
                      <Link
                        to="#"
                        className={`password-addon ${
                          showPass ? "icon-eye" : "icon-eye-off"
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowPass(!showPass);
                        }}
                      />
                    </div>

                    {checkPassword && (
                      <PasswordChecklist
                        rules={[
                          "minLength",
                          "specialChar",
                          "number",
                          "capital",
                          "match",
                          "noSpaces",
                          "capitalAndLowercase",
                          "notEmpty",
                        ]}
                        minLength={10}
                        value={password}
                        valueAgain={password_confirmation}
                        messages={{
                          minLength: t("checkpass.minLength"),
                          specialChar: t("checkpass.specialChar"),
                          number: t("checkpass.number"),
                          capital: t("checkpass.capital"),
                          match: t("checkpass.match"),
                          noSpaces: t("checkpass.noSpaces"),
                          capitalAndLowercase: t(
                            "checkpass.capitalAndLowercase"
                          ),
                          notEmpty: t("checkpass.notEmpty"),
                        }}
                        onChange={setIsValid}
                      />
                    )}
                  </div>

                  <div className="ip">
                    <label>
                      {t("account.AccountConfirmPass")}
                      <span>*</span>
                    </label>
                    <div className="inputs-group auth-pass-inputgroup">
                      <input
                        type={showPass2 ? "text" : "password"}
                        className="input-form password-input"
                        name="password_confirmation"
                        value={password_confirmation}
                        onChange={handleFormChange}
                        placeholder={t("account.AccountPass")}
                        required
                      />
                      <Link
                        to="#"
                        className={`password-addon ${
                          showPass2 ? "icon-eye" : "icon-eye-off"
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowPass2(!showPass2);
                        }}
                      />
                    </div>

                    {checkPasswordConfirmation && (
                      <PasswordChecklist
                        rules={["match", "notEmpty"]}
                        value={password}
                        valueAgain={password_confirmation}
                        messages={{
                          match: t("checkpass.match"),
                          notEmpty: t("checkpass.notEmpty"),
                        }}
                        onChange={(isValid) => {
                          // La validation du mot de passe principal détermine toujours isValid globalement
                          // Nous ne changeons pas isValid ici
                        }}
                      />
                    )}
                  </div>

                  <div className="group-ant-choice st">
                    <div className="sub-ip">
                      <input
                        type="checkbox"
                        name="checkbox_terms"
                        checked={is_checked}
                        onChange={handleFormChange}
                      />
                      {t("account.AccountAccept")}
                      <Link to="/termsofuse">
                        {" "}
                        {t("account.AccountTermOfUse")}
                      </Link>
                    </div>
                    {renderErrorMessage(errors.is_checked)}
                  </div>

                  <div className="group-ant-choice st">
                    <button
                      type="submit"
                      disabled={!isValid}
                      className="login-button"
                    >
                      {isLoading ? (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            width: "100%",
                          }}
                        >
                          <ReactLoading
                            type="spin"
                            color="white"
                            height={30}
                            width={30}
                          />
                          {t("signin.loading")}
                        </span>
                      ) : (
                        t("account.AccountCreate")
                      )}
                    </button>
                    &nbsp;&nbsp;
                  </div>

                  <div className="sign-up">
                    {t("account.AccountExist")}
                    <Link to="/login">
                      &nbsp; {t("account.AccountConnexion")}
                    </Link>
                    <br />
                    <br />
                    <Link
                      to={process.env.REACT_APP_CLIENT_SERVICE}
                      className="btn-social"
                    >
                      {t("signin.siteWeb")}
                    </Link>
                  </div>
                </form>
              </TabPanel>
            </div>
          </Tabs>
        </div>
      </div>
    </section>
  );
}

export default SignUp;
